/** @format */

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProductSocialContentState } from '../../model';

// Interface for the feature state structure that wraps the actual social content data
interface ProductSocialContentFeatureState {
	productSocialContentState: ProductSocialContentState;
}

/**
 * @description
 * Returns either the number of total results, the individual social content items (with products and media), or just the media / images for the social items
 */

export const selectProductSocialContentFeature =
	createFeatureSelector<ProductSocialContentFeatureState>('productSocialContent');

// Select the core social content data from within the feature state
export const selectProductSocialContentData = createSelector(
	selectProductSocialContentFeature,
	(featureState) => featureState.productSocialContentState
);

export const selectProductSocialContentNumberResults = createSelector(
	selectProductSocialContentData,
	(socialContent) => socialContent.resultsCount
);

export const selectProductSocialContentItems = createSelector(
	selectProductSocialContentData,
	(socialContent) => socialContent.items
);

export const selectProductSocialContentImages = createSelector(
	selectProductSocialContentData,
	(socialContent) => socialContent?.items?.map((item, index) => ({...item.media, id: index})) || []
);

export const selectProductSocialContentModal = createSelector(
	selectProductSocialContentData,
	(socialContent) => socialContent?.socialModal || false
);

export const selectProductSocialCarouselIndex = createSelector(
	selectProductSocialContentData,
	(socialContent) => socialContent?.socialCarouselIndex || 0
);
